function stableStrategyValue(value) {
  if (Array.isArray(value)) return value.map(stableStrategyValue);
  if (value && typeof value === "object") {
    return Object.keys(value).sort().reduce((acc, key) => {
      if ([
        "archiveStatus",
        "archivedAt",
        "baseName",
        "createdAt",
        "description",
        "display",
        "displaySettings",
        "id",
        "isActive",
        "lockedAt",
        "mode",
        "notes",
        "scheduledAt",
        "strategyId",
        "strategyName",
        "trackingMode",
        "tracking_mode",
        "updatedAt",
        "version",
        "versionNumber",
        "version_number",
      ].includes(key)) return acc;
      acc[key] = stableStrategyValue(value[key]);
      return acc;
    }, {});
  }
  return value;
}

function normalizePlayNumbers(play) {
  if (Array.isArray(play)) return play.map(n => Number(n));
  if (play && typeof play === "object" && Array.isArray(play.numbers)) {
    return play.numbers.map(n => Number(n));
  }
  return null;
}

function normalizePickLineRules(play, fallbackRules = null) {
  const fallback = fallbackRules && typeof fallbackRules === "object" ? fallbackRules : {};
  const item = play && typeof play === "object" && !Array.isArray(play) ? play : {};
  const nested = item.pickRules || item.rules || item.playRules || {};
  const pick = (...values) => values.find(value => value !== undefined && value !== null && value !== "");
  const rules = {
    playType: pick(item.playType, item.play_type, item.type, nested.playType, nested.play_type, nested.type, fallback.playType, fallback.play_type, "Straight"),
    wager: Number(pick(item.wager, item.amount, nested.wager, nested.amount, fallback.wager, fallback.amount, 1)) || 1,
    multiple: Math.max(1, Number(pick(item.multiple, item.multiplier, nested.multiple, nested.multiplier, fallback.multiple, fallback.multiplier, 1)) || 1),
    fireball: !!pick(item.fireball, item.fireballEnabled, nested.fireball, nested.fireballEnabled, fallback.fireball, fallback.fireballEnabled, false),
  };
  const cost = Number(pick(item.cost, item.estimatedCost, item.ticketCost, nested.cost, nested.estimatedCost, nested.ticketCost));
  if (Number.isFinite(cost) && cost >= 0) rules.cost = cost;
  const permutationCount = Number(pick(item.permutationCount, item.ways, nested.permutationCount, nested.ways));
  if (Number.isFinite(permutationCount) && permutationCount >= 0) rules.permutationCount = permutationCount;
  const representedTickets = Number(pick(item.representedTickets, item.represented_plays, nested.representedTickets, nested.represented_plays));
  if (Number.isFinite(representedTickets) && representedTickets >= 0) rules.representedTickets = representedTickets;
  return rules;
}

function isPickGameId(game) {
  return ["pick2", "pick3", "pick4", "pick5"].includes(String(game || "").toLowerCase());
}

function strategyOutcomeSnapshot({ game, plays = [], pickRules = null }) {
  const gameId = game || "fantasy5";
  const normalizedPlays = (plays || [])
    .map(play => {
      const numbers = normalizePlayNumbers(play);
      if (!numbers || !numbers.length || numbers.some(n => !Number.isFinite(n))) return null;
      if (!isPickGameId(gameId)) return numbers;
      return {
        numbers,
        pickRules: normalizePickLineRules(play, pickRules),
      };
    })
    .filter(Boolean)
    .sort((a, b) => JSON.stringify(stableStrategyValue(a)).localeCompare(JSON.stringify(stableStrategyValue(b))));
  const cost = pickRules && pickRules.cost !== undefined && pickRules.cost !== null
    ? Number(pickRules.cost)
    : NaN;
  return stableStrategyValue({
    game: gameId,
    numbers: normalizedPlays,
    pickRules: pickRules || null,
    playCount: normalizedPlays.length,
    estimatedCost: Number.isFinite(cost) ? cost : normalizedPlays.length,
  });
}

function strategyFingerprint(snapshot) {
  const text = JSON.stringify(stableStrategyValue(snapshot || {}));
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = ((hash << 5) - hash) + text.charCodeAt(i);
    hash |= 0;
  }
  return "fp_" + Math.abs(hash).toString(36) + "_" + text.length.toString(36);
}

module.exports = {
  stableStrategyValue,
  strategyOutcomeSnapshot,
  strategyFingerprint,
};
